module.exports = __webpack_public_path__ + "img/4.980b107e.png";